var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4593_5147",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.706177,
    width: 15,
    height: 15,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4593_5147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.72193 11.2035C9.27393 11.2035 8.89368 11.0497 8.58118 10.7422C8.26868 10.4347 8.11243 10.0622 8.11243 9.62474C8.11243 9.17724 8.26868 8.79699 8.58118 8.48399C8.89368 8.17199 9.27393 8.01599 9.72193 8.01599C10.1594 8.01599 10.5317 8.17199 10.8387 8.48399C11.1462 8.79699 11.2999 9.17724 11.2999 9.62474C11.2999 10.0622 11.1462 10.4347 10.8387 10.7422C10.5317 11.0497 10.1594 11.2035 9.72193 11.2035ZM3.89368 13.7497C3.52918 13.7497 3.21918 13.6222 2.96368 13.3672C2.70868 13.1117 2.58118 12.8017 2.58118 12.4372V3.87524C2.58118 3.51074 2.70868 3.20074 2.96368 2.94524C3.21918 2.69024 3.52918 2.56274 3.89368 2.56274H4.39393V1.90649C4.39393 1.72949 4.45893 1.57574 4.58893 1.44524C4.71943 1.31524 4.87318 1.25024 5.05018 1.25024C5.22718 1.25024 5.38068 1.31524 5.51068 1.44524C5.64118 1.57574 5.70643 1.72949 5.70643 1.90649V2.56274H10.7059V1.90649C10.7059 1.72949 10.7712 1.57574 10.9017 1.44524C11.0317 1.31524 11.1852 1.25024 11.3622 1.25024C11.5392 1.25024 11.6929 1.31524 11.8234 1.44524C11.9534 1.57574 12.0184 1.72949 12.0184 1.90649V2.56274H12.5187C12.8832 2.56274 13.1932 2.69024 13.4487 2.94524C13.7037 3.20074 13.8312 3.51074 13.8312 3.87524V12.4372C13.8312 12.8017 13.7037 13.1117 13.4487 13.3672C13.1932 13.6222 12.8832 13.7497 12.5187 13.7497H3.89368ZM3.89368 12.4372H12.5187V6.28124H3.89368V12.4372ZM3.89368 4.96874H12.5187V3.87524H3.89368V4.96874Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventWhite);
export default __webpack_public_path__ + "static/media/event_white.f1162b7771302827b9f50579db75614a.svg";
export { ForwardRef as ReactComponent };